import { searchIsLoadingSelector } from 'selectors/availabilitySearchSelectors';
import { useSelector } from 'react-redux';

/**
 * convenience hook for getting if a request is being made that search page cares about
 * is true for lock, config, and availability requests loading
 */
export function useSearchRequestInProgress(): boolean {
  const isLoading = useSelector(searchIsLoadingSelector);
  return isLoading;
}
